export default "__VITE_ASSET__DkrRMXys__"